
































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { Route } from 'vue-router';

// Define the possible types for the 'tag' prop for better type safety
type ButtonTag = 'button' | 'a' | 'input' | 'router-link' | 'nuxt-link' | string;

@Component({
  // This prevents attributes not defined as props (like 'aria-label')
  // from being automatically applied to the root <div>, and instead allows
  // us to pass them to the <b-button> with v-bind="$attrs".
  inheritAttrs: false,
})
export default class BaseButton extends Vue {
  // --- Exposing Buefy's Core Props ---

  @Prop({ type: String, default: '' })
  readonly type!: string; // e.g., 'is-primary', 'is-text', 'is-danger'

  @Prop({ type: String, default: '' })
  readonly size!: string; // e.g., 'is-small', 'is-medium', 'is-large'

  @Prop({ type: String, default: '' })
  readonly label!: string;

  @Prop({ type: String, default: '' })
  readonly iconLeft!: string;

  @Prop({ type: String, default: '' })
  readonly iconRight!: string;

  @Prop({ type: Boolean, default: false })
  readonly loading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly expanded!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly rounded!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly outlined!: boolean;

  // Add a prop to control the font weight.
  // It defaults to 'false', so buttons will not be bold by default.
  @Prop({ type: Boolean, default: false })
  readonly bold!: boolean;

  // --- Props for Link/Router Functionality ---

  @Prop({ type: String, default: 'button' })
  readonly tag!: ButtonTag;

  // Prop for 'to' when using 'router-link' or 'nuxt-link'
  @Prop({ type: [String, Object], default: null })
  readonly to!: string | Partial<Route> | null;

  // --- Event Handling ---

  @Emit('click')
  handleClick(event: MouseEvent) {
    // We simply re-emit the click event.
    // This allows parent components to listen with @click.
    return event;
  }
}
